import {T, useTranslate} from '@tolgee/react'
import {Box, DialogBody, DialogHeader, DialogFooter, Text, Button} from '@chakra-ui/react'
import {dialog} from '@cypro/ui/components'
import {OverdosePreventionLevel} from '@cypro/engine/database/schema'

function onClose() {
  dialog.close('overdose-warning', true)
}

export function OverdoseWarningDialog({
  overdosePreventionLevel,
  onSubmit,
  onCancel,
  name,
  limit,
  unit,
}: {
  overdosePreventionLevel: OverdosePreventionLevel
  name: string
  limit: number
  unit: string
  onSubmit: () => void | Promise<unknown>
  onCancel?: () => void
}) {
  const {t} = useTranslate('common')

  return (
    <>
      <DialogHeader>
        <Box display={'flex'} flexDirection={'column'} gap="1">
          <Text fontWeight={'semibold'} fontSize={'lg'}>
            {overdosePreventionLevel === OverdosePreventionLevel.enum.HARD_STOP
              ? t('overdose.prescription_blocked')
              : t('overdose.warning')}
          </Text>
          <Text fontWeight={'normal'} fontSize={'md'} color="fg.muted">
            {t('overdose.limit_exceeded')}
          </Text>
        </Box>
      </DialogHeader>

      <DialogBody minHeight={'none'} maxWidth={'100%'}>
        <Box display={'flex'} flexDirection={'row'} gap="4" justifyContent={'center'} alignItems={'center'}>
          <Text fontSize={'sm'} fontWeight={'normal'}>
            {overdosePreventionLevel === OverdosePreventionLevel.enum.HARD_STOP ? (
              <T
                keyName="overdose.prescription_blocked.body"
                params={{
                  name: name,
                  maxLimit: limit.toFixed(2),
                  unit: unit,
                  b: <Text as="span" fontWeight="bold" />,
                }}
              />
            ) : (
              <T
                keyName="overdose.warning.body"
                params={{
                  name: name,
                  maxLimit: limit.toFixed(2),
                  unit: unit,
                  b: <Text as="span" fontWeight="bold" />,
                }}
              />
            )}
          </Text>
        </Box>
      </DialogBody>

      <DialogFooter display="flex" justifyContent="flex-end" gapX="3">
        {overdosePreventionLevel !== OverdosePreventionLevel.enum.HARD_STOP && (
          <Button
            variant="outline"
            onClick={() => {
              onCancel?.()
              onClose()
            }}
          >
            {t('cancel')}
          </Button>
        )}
        <Button
          onClick={async () => {
            if (overdosePreventionLevel === OverdosePreventionLevel.enum.HARD_STOP) {
              onClose()
            } else {
              await onSubmit()
              onClose()
            }
          }}
          colorPalette={overdosePreventionLevel === OverdosePreventionLevel.enum.HARD_STOP ? 'red' : 'cyan'}
        >
          {overdosePreventionLevel === OverdosePreventionLevel.enum.HARD_STOP
            ? t('overdose.adjust_dose')
            : t('overdose.proceed')}
        </Button>
      </DialogFooter>
    </>
  )
}
